module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [(_vm.ehVisualizacao) ? _c('span', [_vm._v("Visualizar " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : (_vm.etapa === 'Análise Financeira') ? _c('span', [_vm._v("Acerto Contábil de " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : _c('span', [_vm._v(_vm._s(_vm.etapa) + " de " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), ((!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos) || _vm.ehVisualizacao) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id)) && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos)),
      expression: "(!loading.processo && !loading.tarefa && !loading.adiantamentos && !loading.projetos)"
    }]
  }, [(!_vm._.isNull(_vm.id) && _vm.processo === 'ADIANTAMENTO') ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>199 - Comunicado Interno de Adiantamento (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(199)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 199\n        ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(219)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 219\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>222 - Extrato de Projeto (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(222)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 222\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>248 - Monitoramento Administrativo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(248)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 248\n        ")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && _vm.etapa !== 'Solicitação') ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5>Faz o download de todos os arquivos da solicitação (zip)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDownloadZIP()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" Baixar arquivos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), ((!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos) && !_vm._.isEmpty(_vm.projeto) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5>' + (_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) ? 'Ao Concluir esta solicitação será encaminhada para Análise da Fundação BB' : (_vm.aprovacao.resultadoAprovacao ? 'Será encaminhado para ' + _vm.aprovacao.resultadoAprovacao : 'Aguadando decisão')) + '</h5>'
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.concluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela && !_vm.loading.cronograma && !_vm._.isEmpty(_vm.projeto) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5>Salva esta solicitação<br/>Para encaminhá-la deve-se usar o botão de Concluir' + (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.poderes.codigo !== 'DIRIGENTE_SEM_RESTRICAO' ? '<br/>Somente dirigentes estão habilitados para concluir solicitações' : (_vm.poderes.mensagem.length > 0 ? '<br/>Restrições:<br/>' + _vm._.join(_vm.poderes.mensagem, ', ') : '')) + '</h5>'
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm.loading.tela && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0 && (_vm.etapa === 'Solicitação' || _vm.etapa === 'Revisão') && !_vm._.isEmpty(_vm.projeto)) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5> Abrir Chamado referente a solicitação atual</h5>'
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "error",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.abrirChamado($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa  fa-comment-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Abrir Chamado")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: (_vm._.isNull(_vm.id) ? 'Solicitações' : 'Validação'),
        href: '#'
      }, {
        text: _vm.descricaoProcesso[_vm.processo],
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm._.isEmpty(_vm.projeto) && _vm._.isNull(_vm.id) && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaProjetos"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    class: _vm.ehVisualizacao ? 'fa fa-caret-right' : 'fa fa-pencil',
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Selecione o projeto")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listaProjetos.length === 0),
      expression: "listaProjetos.length === 0"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto),
      expression: "projeto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projeto",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selecionaProjeto()
      }]
    }
  }, _vm._l((_vm.listaProjetos), function(projetoDisponivel) {
    return _c('option', {
      domProps: {
        "value": projetoDisponivel
      }
    }, [_vm._v(_vm._s(projetoDisponivel.Projeto))])
  }), 0)])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id)) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "solicitacao"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.processo || _vm.loading.tarefa || _vm.loading.adiantamentos || _vm.loading.projetos),
      expression: "loading.processo || loading.tarefa || loading.adiantamentos || loading.projetos"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (!_vm._.isEmpty(_vm.chamado) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v(" * Atenção: O processo que será analisado possui chamado vinculado - "), _c('b', _vm._l((_vm.chamado), function(c, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'cadastro-chamado-edita',
          params: {
            id: c.id
          }
        }
      }
    }, [_vm._v(" " + _vm._s(c.id) + " "), (_vm.chamado.length > 1 && index === 0) ? _c('span', [_vm._v(",  ")]) : _vm._e()])], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.adiantamentoSolicitado.suporteFbb.length > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v("\n            ** Atenção: Este processo possui " + _vm._s(_vm.adiantamentoSolicitado.suporteFbb.length > 1 ? 'os seguintes suportes vinculados' : 'este suportes vinculado') + ":\n            "), _vm._l((_vm.adiantamentoSolicitado.suporteFbb), function(suporte) {
    return _c('a', {
      staticStyle: {
        "font-weight": "bold",
        "padding-left": "10px"
      },
      attrs: {
        "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(suporte.numero))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.adiantamentoSolicitado.suporteFbb.length > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v("\n            ** Atenção: Este processo possui " + _vm._s(_vm.adiantamentoSolicitado.suporteFbb.length > 1 ? 'os seguintes suportes vinculados' : 'este suportes vinculado') + ":\n            "), _vm._l((_vm.adiantamentoSolicitado.suporteFbb), function(suporte) {
    return _c('a', {
      staticStyle: {
        "font-weight": "bold",
        "padding-left": "10px"
      },
      attrs: {
        "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(suporte.numero))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm._.includes(['PRESTACAO_DE_CONTAS', 'PAGAMENTO', 'ADIANTAMENTO', 'RESSARCIMENTO'], _vm.processo) && _vm._.includes(['Solicitação'], _vm.etapa) && _vm.projetoComAlteracaoEmAndamento) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Solicitação não disponível. Verificamos que há uma alteração de projetos em andamento.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              " + _vm._s(_vm.projeto.Projeto) + "\n              "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm._.has(_vm.projeto, 'Status_ERP')) ? _c('span', [_vm._v("\n                ("), _c('strong', [_vm._v(_vm._s(_vm.projeto.Status_ERP))]), _vm._v(")\n                  "), _c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'small',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para a página do Projeto</h5>',
      "to": {
        name: 'projeto',
        params: {
          numero: _vm.projeto.Numero_projeto
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-external-link"
  })])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [(_vm.restricaoParaInicializar.length > 0) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.restricaoParaInicializar), function(restricao) {
    return _c('p', [_vm._v(_vm._s(restricao))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.ultimaTarefaFeita, 'observacao') && !_vm._.isNull(_vm.ultimaTarefaFeita.observacao)) ? _c('div', {
    staticClass: "alert alert-info alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ultimaTarefaFeita.observacao))])]) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Solicitação'], _vm.etapa)) ? _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome da entidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
      "to": {
        name: 'cadastro-entidade-visualiza',
        params: {
          id: _vm.projeto.fk_entidade
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.razaoSocial) + "  "), _c('i', {
    staticClass: "fa fa-external-link"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.projetoSuperior))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    on: {
      "click": function($event) {
        _vm.mostrar_representantes = !_vm.mostrar_representantes
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar_representantes ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Representantes Legais:")]), _vm._v(" "), (_vm.mostrar_representantes) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.dirigentes), function(dirigente) {
    return (dirigente.bt_ativo && dirigente.bt_assinatura_entidade) ? _c('tr', [_c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm.cargos[dirigente.fk_cargo_mandato]))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]) : _vm._e()
  }), 0)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    on: {
      "click": function($event) {
        _vm.mostrar_ocorrencias = !_vm.mostrar_ocorrencias
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar_ocorrencias ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocorrências:")]), _vm._v(" "), (_vm.temOcorrencia) ? _c('div', [(_vm.mostrar_ocorrencias) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.ocorrencias), function(ocorrencia) {
    return _c('tr', [_c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(ocorrencia.codigo) + " " + _vm._s(ocorrencia.descricao))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("moment")(ocorrencia.inicio, "L")))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(ocorrencia.observacao))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(ocorrencia.etapa))])])
  }), 0)])])])]) : _vm._e()]) : _c('div', [_vm._m(5)])])]) : _vm._e(), _vm._v(" "), (_vm.adiantamentosConcecidos.length > 0 && _vm._.has(_vm.adiantamentosConcecidos[0], 'id')) ? _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "adiantamentosConcedidos"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w10",
    attrs: {
      "title": '<h5>Id da solicitação de adiantamento</h5>'
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w15",
    attrs: {
      "title": '<h5>Número da parcela (ordem) do adiantamento</h5>'
    }
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w15",
    attrs: {
      "title": '<h5>Data quando foi feita a solicitação de liberação do adiantamento</h5>'
    }
  }, [_vm._v("Data da solicitação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w15",
    attrs: {
      "title": '<h5>Valor da parcela no instrumento legal</h5>'
    }
  }, [_vm._v("Valor previsto")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w15",
    attrs: {
      "title": '<h5>% Comprovada da parcela, considerando somente prestações de contas efetivamente aprovadas pela Fundação</h5>'
    }
  }, [_vm._v("% Comprov.")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w15",
    attrs: {
      "title": '<h5>Valor solicitado dentro do limite total da parcela</h5>'
    }
  }, [_vm._v("Valor adiantado")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w15",
    attrs: {
      "title": '<h5>Data limite para realizar as Prestações de Contas para esta parcela</h5>'
    }
  }, [_vm._v("Data limite para prestação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda w15",
    attrs: {
      "title": '<h5>Data da última Prestação de Contas solicitda para esta parcela</h5>'
    }
  }, [_vm._v("Data da última prestação")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.adiantamentosConcecidos), function(adiantamento) {
    return [_c('tr', [_c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v("\n                              " + _vm._s(adiantamento.id) + "\n\n                              "), _vm._v(" "), (false) ? _c('router-link', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          placement: 'right',
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia:true, placement:'right', animation:'perspective', distance:'1', size: 'large', arrow:true }"
      }],
      attrs: {
        "title": '<h5>Clique aqui para abrir este processo de solicitação de adiantamento realizado</h5>',
        "to": {
          name: 'solicitacao-adiantamento',
          params: {
            id: adiantamento.id,
            visualizacao: true
          }
        },
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    })]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v("\n                              " + _vm._s(adiantamento.parcela) + " "), _c('span', {
      staticStyle: {
        "color": "var(--cor-destaque)",
        "font-size": "x-small"
      }
    }, [_vm._v(_vm._s(adiantamento.recurso))])]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("moment")(adiantamento.data_solicitacao, "L")))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.contratado)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_c('span', {
      style: ((((adiantamento.requisitado - (adiantamento.em_execucao + adiantamento.pendente_comprovacao)) / adiantamento.requisitado)) < 0.8 ? 'color: var(--cor-vermelha)' : '')
    }, [_vm._v(_vm._s((((adiantamento.requisitado - (adiantamento.em_execucao + adiantamento.pendente_comprovacao)) / adiantamento.requisitado) * 100).toFixed(2)) + " %")])]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.requisitado)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("moment")(adiantamento.data_limite_prestacao, "L")))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("moment")(adiantamento.data_ultima_prestacao, "L")))])])]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_vm._m(7), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor",
    staticStyle: {
      "padding": "10px",
      "font-size": "2rem"
    }
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.liberado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor",
    staticStyle: {
      "padding": "10px",
      "font-size": "2rem"
    }
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total de prestações de contas Em Execução (solicitadas mas ainda não aprovadas pela Fundação BB)</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.emExecucao)) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor",
    staticStyle: {
      "padding": "10px",
      "font-size": "2rem"
    }
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total pendente de prestação de contas é o total de adiantamento solicitado subtraindo prestações solicitadas e adicionando devoluções realizadas</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.pendenteComprovacao)) + "\n                            ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length === 0 && _vm.parcelasAtuais.length > 0) ? _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "parcelasAdiantamentoDisponiveis"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? (_vm.projeto.parcelas_contratadas > 1 ? 'Parcelas Adiantáveis' : 'Parcela Adiantável') : 'Valor para Devolução'))]), _vm._v(" "), (_vm.projeto.superior === 18182 && _vm.projeto.parcelas_contratadas === 1) ? _c('span', {
    staticStyle: {
      "color": "var(--cor-destaque)"
    }
  }, [_vm._v("Este projeto tem parcela única e deve ser liberado integralmente")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [(_vm.processo === 'ADIANTAMENTO') ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Número da parcela (ordem) do adiantamento</h5>'
    }
  }, [_vm._v("Parcela")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Origem do recurso financeiro</h5>'
    }
  }, [_vm._v("Recurso")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Total orçado do recurso nesta parcela' : 'É o total do valor adiantado que ainda não foi prestado contas nem devolvido') + '</h5>'
    }
  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor total' : 'Total pendente'))]), _vm._v(" "), (_vm.parcelasAtuais.length > 1 && _vm.processo === 'ADIANTAMENTO' && _vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'top'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Total disponível do recurso nesta parcela considerando os totais do projeto' : 'É o total do valor adiantado disponível que ainda não foi prestado contas nem devolvido') + '</h5>'
    }
  }, [_vm._v("Valor disponível")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Valor solicitado dentro do limite total da parcela' : 'Limite que pode devolver nesta solicitação') + '</h5>'
    }
  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor solicitado' : 'Valor para devolução'))]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Total não solicitado nesta parcela' : 'Valor pendente de devolução ou prestação de contas') + '</h5>'
    }
  }, [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Saldo restante' : 'Total Restante'))]), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Número do título que será gerado no Sapiens</h5>'
    }
  }, [_vm._v("Número do Título")]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Conta financeira de adiantamento ao qual o projeto esta vinculado</h5>'
    }
  }, [_vm._v("Conta Financeira")]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Conta de tesouraria ao qual o projeto esta vinculado</h5>'
    }
  }, [_vm._v("Conta de Tesouraria")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.parcelasAtuais), function(parcela, idx) {
    return [_c('tr', [(_vm.processo === 'ADIANTAMENTO') ? _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(parcela.parcela))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(parcela.resourceSource))]), _vm._v(" "), (idx === 0) ? _c('td', {
      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20'),
      attrs: {
        "rowspan": _vm.parcelasAtuais.length
      }
    }, [_vm._v(_vm._s(_vm._f("real")(parcela.disponivel)))]) : _vm._e(), _vm._v(" "), (_vm.parcelasAtuais.length > 1 && _vm.processo === 'ADIANTAMENTO' && _vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
      staticClass: "celula centralizado borda w15"
    }, [((parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) < parcela.disponivel) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "atencao",
      staticStyle: {
        "background": "steelblue !important"
      },
      attrs: {
        "title": '<h5>Este é o valor restante no projeto em recursos de ' + parcela.resourceSource + '</h5>'
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm._.round((parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) - parcela.requisitado, 2))) + "\n                              ")]) : _c('span', [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm._.round(parcela.disponivel - parcela.requisitado, 2))) + "\n                              ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20')
    }, [((_vm.processo === 'ADIANTAMENTO')) ? _c('money', {
      staticClass: "form-control valorSolicitacao",
      attrs: {
        "name": "valor a solicitar",
        "type": "text",
        "disabled": _vm.ehVisualizacao || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) || (_vm.projeto.superior === 18182 && _vm.projeto.parcelas_contratadas === 1)
      },
      nativeOn: {
        "keyup": function($event) {
          parcela.requisitado = _vm.limitaFaixaEntrada('decimal', parcela.requisitado, 0,
            ((parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) < parcela.disponivel) ?
            (parcela.resourceSource === 'FUNDACAO' ? _vm.totais.projeto.fbb.limite : _vm.totais.projeto.parceiros.limite) : parcela.disponivel)
        },
        "blur": function($event) {
          return _vm.calcularTotaisAdiantamento($event)
        }
      },
      model: {
        value: (parcela.requisitado),
        callback: function($$v) {
          _vm.$set(parcela, "requisitado", $$v)
        },
        expression: "parcela.requisitado"
      }
    }) : _vm._e(), _vm._v(" "), ((_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO')) ? _c('money', {
      staticClass: "form-control valorSolicitacao",
      attrs: {
        "name": "valor a solicitar",
        "type": "text",
        "disabled": _vm.ehVisualizacao || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
      },
      nativeOn: {
        "blur": function($event) {
          return _vm.calcularTotaisAdiantamento($event)
        }
      },
      model: {
        value: (parcela.requisitado),
        callback: function($$v) {
          _vm.$set(parcela, "requisitado", $$v)
        },
        expression: "parcela.requisitado"
      }
    }) : _vm._e()], 1), _vm._v(" "), (_vm.parcelasAtuais.length === 1) ? _c('td', {
      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20')
    }, [_vm._v(_vm._s(_vm._f("real")(_vm._.round((parcela.disponivel - parcela.requisitado), 2))))]) : (idx === 0) ? _c('td', {
      class: 'celula centralizado borda ' + (_vm.processo === 'ADIANTAMENTO' ? 'w15' : 'w20'),
      attrs: {
        "rowspan": _vm.parcelasAtuais.length
      }
    }, [_c('span', {
      class: _vm._.round(((_vm._.sumBy(_vm.parcelasAtuais, 'disponivel')) - _vm._.sumBy(_vm.parcelasAtuais, 'requisitado')), 2) < 0 ? 'atencao' : ''
    }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm._.round((_vm._.sumBy(_vm.parcelasAtuais, 'disponivel') - _vm._.sumBy(_vm.parcelasAtuais, 'requisitado')), 2))) + "\n                              ")])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
      staticClass: "celula centralizado borda w15"
    }, [(parcela.requisitado > 0) ? _c('span', {
      class: {
        'has-error': _vm.errors.first('número do título da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcela.numeroTitulo),
        expression: "parcela.numeroTitulo"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control valorSolicitacao",
      attrs: {
        "name": 'número do título da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource,
        "type": "number",
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
      },
      domProps: {
        "value": (parcela.numeroTitulo)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parcela, "numeroTitulo", $event.target.value)
        }
      },
      nativeOn: {
        "keyup": function($event) {
          parcela.numeroTitulo = _vm.limitaFaixaEntrada('inteiro', parcela.numeroTitulo, 0, 99999999)
        }
      }
    })]) : _c('span', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
      staticClass: "celula centralizado borda w20"
    }, [(parcela.requisitado > 0) ? _c('span', {
      class: {
        'has-error': _vm.errors.first('conta financeira da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource)
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcela.contaFinanceira),
        expression: "parcela.contaFinanceira"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'conta financeira da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource,
        "aria-hidden": "true",
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parcela, "contaFinanceira", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.contasFinanceiras), function(conta) {
      return _c('option', {
        domProps: {
          "value": conta.ctared
        }
      }, [_vm._v(_vm._s(conta.ctared) + " / " + _vm._s(conta.descta))])
    }), 0)]) : _c('span', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'ADIANTAMENTO' && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('td', {
      staticClass: "celula centralizado borda w20"
    }, [(parcela.requisitado > 0) ? _c('span', {
      class: {
        'has-error': _vm.errors.first('conta tesouraria da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource)
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcela.contaTesouraria),
        expression: "parcela.contaTesouraria"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'conta tesouraria da parcela ' + parcela.parcela + ' de ' + parcela.resourceSource,
        "aria-hidden": "true",
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parcela, "contaTesouraria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.contasTesouraria), function(conta) {
      return _c('option', {
        domProps: {
          "value": conta.numcco
        }
      }, [_vm._v(_vm._s(conta.numcco) + " / " + _vm._s(conta.descco))])
    }), 0)]) : _c('span', [_vm._v(" ")])]) : _vm._e()])]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_c('tr', [_c('td', {
    staticClass: "centralizado w30"
  }, [_c('span', [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor orçado para esta parcela' : 'Total Pendente'))])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado w30"
  }, [_c('span', [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Total valor solicitado' : 'Total para devolução'))])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado w30"
  }, [_c('span', [_vm._v(_vm._s(_vm.processo === 'ADIANTAMENTO' ? 'Valor disponível para solicitação nesta parcela' : 'Valor ainda não comprovado nem devolvido'))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>' + (_vm.processo === 'ADIANTAMENTO' ? 'Valor total disponível nesta parcela do projeto' : 'Soma dos valores em aberto dos adiantamento concedidos que podem ser devolvidos') + '</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm._.round(_vm._.sumBy(_vm.parcelasAtuais, 'disponivel'), 2))) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor solicitado neste pedido de ' + _vm._.toLower(_vm.descricaoProcesso[_vm.processo]) + '</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm._.sumBy(_vm.parcelasAtuais, 'requisitado'))) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor disponível que não foi solicitado</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm._.round(((_vm._.sumBy(_vm.parcelasAtuais, 'disponivel')) - _vm._.sumBy(_vm.parcelasAtuais, 'requisitado')), 2))) + "\n                            ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['ADIANTAMENTO'], _vm.processo) && (!_vm.loading.processo && !_vm.loading.tarefa && !_vm.loading.adiantamentos && !_vm.loading.projetos) && _vm.restricaoParaInicializar.length === 0) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('banco')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.adiantamentoSolicitado.formaPagamento !== 4
      }),
      expression: "{required: adiantamentoSolicitado.formaPagamento !== 4}"
    }],
    attrs: {
      "options": _vm.listaBancos,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Selecione um banco",
      "custom-label": _vm.bancoNome,
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "banco",
      "data-vv-as": "banco",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.restricaoParaInicializar.length > 0 || _vm.bancoSelecionado
    },
    on: {
      "select": _vm.selecionaBanco
    },
    model: {
      value: (_vm.bancoSelecionado),
      callback: function($$v) {
        _vm.bancoSelecionado = $$v
      },
      expression: "bancoSelecionado"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('agência')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5> ' + (_vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? 'Caso existam divergência nos dados bancários informados, gentileza <span class=\'realce\'>abrir um chamado</span>.' : 'Caso existam divergência nos dados bancários informados, gentileza <span class=\'realce\'>abrir um chamado</span>.') + ' </h5>'
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "agência",
      "type": "text",
      "mask": _vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? '####' : '####-X',
      "tokens": _vm.agenciaTokens,
      "disabled": "",
      "masked": ""
    },
    model: {
      value: (_vm.adiantamentoSolicitado.dados_bancarios.agencia),
      callback: function($$v) {
        _vm.$set(_vm.adiantamentoSolicitado.dados_bancarios, "agencia", $$v)
      },
      expression: "adiantamentoSolicitado.dados_bancarios.agencia"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('conta corrente')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Conta " + _vm._s(_vm.adiantamentoSolicitado.dados_bancarios.tipo === 1 ? 'Corrente' : (_vm.adiantamentoSolicitado.dados_bancarios.tipo === 2 ? 'Poupança' : '')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "conta corrente",
      "type": "text",
      "mask": ['#-X', '##-X', '###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X', '##########-X', '###########-X'],
      "tokens": _vm.customTokens,
      "disabled": "",
      "masked": ""
    },
    model: {
      value: (_vm.adiantamentoSolicitado.dados_bancarios.conta),
      callback: function($$v) {
        _vm.$set(_vm.adiantamentoSolicitado.dados_bancarios, "conta", $$v)
      },
      expression: "adiantamentoSolicitado.dados_bancarios.conta"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo da conta')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Tipo da Conta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.adiantamentoSolicitado.formaPagamento !== 4
      }),
      expression: "{required: adiantamentoSolicitado.formaPagamento !== 4}"
    }],
    attrs: {
      "options": _vm.tiposConta,
      "multiple": false,
      "close-on-select": true,
      "preselect-first": true,
      "allow-empty": false,
      "custom-label": _vm.tipoContaNome,
      "placeholder": "Selecione um tipo de conta",
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "",
      "deselectLabel": "",
      "name": "tipo da conta",
      "data-vv-as": "tipo da conta",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.processo === 'PRESTACAO_DE_CONTAS' || _vm.restricaoParaInicializar.length || _vm.contaAdiantamento > 0 || _vm.adiantamentoSolicitado.dados_bancarios.tipo
    },
    on: {
      "select": _vm.selecionaTipoConta
    },
    model: {
      value: (_vm.tipoContaSelecionado),
      callback: function($$v) {
        _vm.tipoContaSelecionado = $$v
      },
      expression: "tipoContaSelecionado"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('tipo da conta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tipo da conta')))]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length === 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos de solicitação de " + _vm._s(_vm._.toLower(_vm.descricaoProcesso[_vm.processo])) + " "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#e32"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php', {
    attrs: {
      "propDocumentos": _vm.adiantamentoSolicitado.documentosAdiantamento,
      "documentTypes": '',
      "disable": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa),
      "local-uso": 'SOLICITACAO_PAGAMENTO'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length === 0) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php', {
    attrs: {
      "propDocumentos": _vm.adiantamentoSolicitado.anexos,
      "documentTypes": '',
      "disable": _vm.ehVisualizacao || _vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa),
      "local-uso": 'SOLICITACAO_PAGAMENTO'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Revisão', 'Análise', 'Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_vm._m(10), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
    key: _vm.historicoBack,
    attrs: {
      "propsValidacao": _vm._.head(_vm.documentosLiberacao),
      "propsHistorico": _vm.historicoBack
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderHistorico === false) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_vm._m(11), _vm._v(" "), _c('historico-antigo', {
    key: _vm.historicoTarefas,
    attrs: {
      "propsValidacao": _vm._.head(_vm.documentosLiberacao),
      "propsHistorico": _vm.historicoTarefas
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType !== 'FUNDACAO' && _vm.restricaoParaInicializar.length === 0)) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adiantamentoSolicitado.observacao),
      expression: "adiantamentoSolicitado.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_opcional",
      "id": "observacao_opcional",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.adiantamentoSolicitado.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
      }
    }
  })])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "decisoes_aprovação"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.processo || _vm.loading.tarefa || _vm.loading.adiantamentos || _vm.loading.projetos),
      expression: "loading.processo || loading.tarefa || loading.adiantamentos || loading.projetos"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": _vm.etapa === 'Análise' ? (_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO' ? 'Análise Financeira' : 'Autorização') : (_vm.etapa === 'Autorização' ? (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão') : (_vm.etapa === 'Liquidação' || _vm.etapa === 'Análise Financeira' ? 'Conclusão' : '')),
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, _vm.etapa === 'Análise' ? (_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO' ? 'Análise Financeira' : 'Autorização') : (_vm.etapa === 'Autorização' ? (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão') : (_vm.etapa === 'Liquidação' || _vm.etapa === 'Análise Financeira' ? 'Conclusão' : '')))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.aprovacao, "resultadoAprovacao", _vm.etapa === 'Análise' ? (_vm.processo === 'DEVOLUCAO_DE_ADIANTAMENTO' ? 'Análise Financeira' : 'Autorização') : (_vm.etapa === 'Autorização' ? (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão') : (_vm.etapa === 'Liquidação' || _vm.etapa === 'Análise Financeira' ? 'Conclusão' : '')))
      }
    }
  }), _vm._v(_vm._s(_vm.etapa === 'Liquidação' ? 'Concluir processo manualmente' : 'Aprovar solicitação') + "\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação', 'Conclusão'], _vm.aprovacao.resultadoAprovacao) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao_decisao"
    }
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adiantamentoSolicitado.observacao),
      expression: "adiantamentoSolicitado.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_decisao",
      "id": "observacao_decisao",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.adiantamentoSolicitado.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.etapa === 'Análise' || _vm.etapa === 'Análise Financeira') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "Revisão",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Revisão")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Revisão")
      }
    }
  }), _vm._v(" Encaminhar para revisão da entidade\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "form-group required-field full col-md-12",
    class: {
      'has-error': _vm.errors.first('motivo de devolucao')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.motivosDevolucao,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Selecione um motivo de Devolução para a entidade",
      "custom-label": _vm.motivoDevolucaoDescricao,
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "motivo de devolucao",
      "data-vv-as": "motivo de devolucao",
      "option-height": 30,
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.motivoDevolucao),
      callback: function($$v) {
        _vm.motivoDevolucao = $$v
      },
      expression: "motivoDevolucao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa_revisão"
    }
  }, [_vm._v("Motivo para revisão:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adiantamentoSolicitado.observacao),
      expression: "adiantamentoSolicitado.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "motivo para revisão",
      "rows": "3",
      "id": "justificativa_revisão",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.adiantamentoSolicitado.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('motivo para revisão')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo para revisão')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "Análise",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Análise")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Análise")
      }
    }
  }), _vm._v(" Retornar para análise\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.aprovacao.resultadoAprovacao === 'Análise' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('justificativa reanalise')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa_reanalise"
    }
  }, [_vm._v("Motivo para reanalisar:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adiantamentoSolicitado.observacao),
      expression: "adiantamentoSolicitado.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa reanalise",
      "rows": "3",
      "id": "justificativa_reanalise",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.adiantamentoSolicitado.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adiantamentoSolicitado, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa reanalise')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa reanalise')))]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Financeira', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.loading.suportesFbbAtivos) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Suportes não encerrados...")]) : _c('span', [_c('multiselect', {
    attrs: {
      "options": _vm.listaSuportes,
      "multiple": true,
      "max": 3,
      "close-on-select": true,
      "placeholder": 'Neste id ' + _vm.id + ' pode ter vinculado opcionalmente de um a três Suportes desta lista de chamados não encerrados',
      "custom-label": _vm.suporteNome,
      "track-by": "numero",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "suporte_fbb",
      "data-vv-as": "suporte_fbb",
      "disabled": _vm.ehVisualizacao
    },
    scopedSlots: _vm._u([{
      key: "maxElements",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v("Já escolheu o limite de três suportes que pode vincular a este ID")])]
      }
    }], null, false, 1318475097),
    model: {
      value: (_vm.adiantamentoSolicitado.suporteFbb),
      callback: function($$v) {
        _vm.$set(_vm.adiantamentoSolicitado, "suporteFbb", $$v)
      },
      expression: "adiantamentoSolicitado.suporteFbb"
    }
  })], 1)])])]) : _vm._e()])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Final do Mandato")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Ocorrência")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Data")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Situação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v("Não há ocorrências ativas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Adiantamentos Concedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "centralizado",
    staticStyle: {
      "padding": "10px",
      "font-size": "1.5rem"
    }
  }, [_c('span', [_vm._v("Total de adiantamento já liberado")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado",
    staticStyle: {
      "padding": "10px",
      "font-size": "1.5rem"
    }
  }, [_c('span', [_vm._v("Total de Prestação de contas em execução")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado",
    staticStyle: {
      "padding": "10px",
      "font-size": "1.5rem"
    }
  }, [_c('span', [_vm._v("Total Pendente de Prestação de contas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dados Bancários")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Anexos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico de solicitação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico Antigo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Observação Opcional")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Decisão")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c0ac3b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/adiantamento/EditaAdiantamento.vue
// module id = 1794
// module chunks = 2